import { NO_CABIN, PLEXI_CABIN, GLASS_CABIN, ARCHE_CABIN } from './circles.scss';

const cabinNames = [NO_CABIN, PLEXI_CABIN, GLASS_CABIN, ARCHE_CABIN];

// -1 => NO_CABIN, 0 => PLEXI_CABIN, 1 => GLASS_CABIN, 2 => ARCHE_CABIN;
// or
// 0 => NO_CABIN, 1 => PLEXI_CABIN, 2 => GLASS_CABIN, 3 => ARCHE_CABIN;
export const cabinForIndex = (index, shift = true) => cabinNames[shift ? index + 1 : index];

export const handleButtonsClick = ($buttons, callback) => {

	$buttons.each((index, button) => {

		// highlight/unhighlight clicked button + update circles wave intensity
		const $button = $(button);
		$button.click(() => {

			let selectedCabin;

			if ($button.hasClass('active')) {
				$button.removeClass('active'); // remove class to clicked button (all unselected)
				selectedCabin = cabinForIndex(-1); // all buttons unselected => full intensity
			}
			else {
				$buttons.removeClass('active'); // remove class from all other buttons
				$button.addClass('active'); // add class to clicked button
				selectedCabin = cabinForIndex(index);
			}

			callback(selectedCabin);
		});
	});
};